import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const getContent = async () => {
  const { data } = await axios.get(`${API}/content`);
  return data;
};

export const postLead = async (lead) => {
  try {
    await axios.post(`${API}/lead`, lead);
  } catch (e) {
    // silent, non-blocking
  }
};

export const goUrl = `${API}/go`;

// ---- admin ----
const tokenKey = "amora_admin_token";
export const getToken = () => localStorage.getItem(tokenKey);
export const setToken = (t) => localStorage.setItem(tokenKey, t);
export const clearToken = () => localStorage.removeItem(tokenKey);

const authHeaders = () => ({ Authorization: `Bearer ${getToken()}` });

export const adminLogin = async (password) => {
  const { data } = await axios.post(`${API}/admin/login`, { password });
  return data;
};

export const adminGetContent = async () => {
  const { data } = await axios.get(`${API}/admin/content`, { headers: authHeaders() });
  return data;
};

export const adminSaveContent = async (content) => {
  const { data } = await axios.put(`${API}/admin/content`, content, { headers: authHeaders() });
  return data;
};

export const adminGetLeads = async (limit = 100) => {
  const { data } = await axios.get(`${API}/admin/leads?limit=${limit}`, { headers: authHeaders() });
  return data;
};

export const adminChangePassword = async (old_password, new_password) => {
  const { data } = await axios.post(
    `${API}/admin/change-password`,
    { old_password, new_password },
    { headers: authHeaders() }
  );
  return data;
};
